import { combineReducers } from 'redux';
import {
    REQUEST_PASSWORD_RESET_INIT,
    SUCCESS_PASSWORD_RESET_INIT,
    FAILURE_PASSWORD_RESET_INIT,
    REQUEST_PASSWORD_RESET_COMMIT,
    SUCCESS_PASSWORD_RESET_COMMIT,
    FAILURE_PASSWORD_RESET_COMMIT
} from './constants';

/*
 * State shape
 {
    fetching: false,
    successPasswordResetInit: false,
    successPasswordResetCommit: false,
    error: ''
 }
*/

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PASSWORD_RESET_INIT:
        case REQUEST_PASSWORD_RESET_COMMIT:
            return true;
        case SUCCESS_PASSWORD_RESET_INIT:
        case SUCCESS_PASSWORD_RESET_COMMIT:
        case FAILURE_PASSWORD_RESET_INIT:
        case FAILURE_PASSWORD_RESET_COMMIT:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PASSWORD_RESET_INIT:
        case FAILURE_PASSWORD_RESET_COMMIT:
            return action.response.message;
        case REQUEST_PASSWORD_RESET_INIT:
        case REQUEST_PASSWORD_RESET_COMMIT:
        case SUCCESS_PASSWORD_RESET_INIT:
        case SUCCESS_PASSWORD_RESET_COMMIT:
            return '';
        default:
            return state;
    }
};

const successPasswordResetInit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_PASSWORD_RESET_INIT:
            return true;
        case REQUEST_PASSWORD_RESET_INIT:
        case FAILURE_PASSWORD_RESET_INIT:
            return false;
        default:
            return state;
    }
};

const successPasswordResetCommit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_PASSWORD_RESET_COMMIT:
            return true;
        case REQUEST_PASSWORD_RESET_COMMIT:
        case FAILURE_PASSWORD_RESET_COMMIT:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    fetching,
    successPasswordResetInit,
    successPasswordResetCommit,
    error
});



// WEBPACK FOOTER //
// ./src/services/authentication/resetpassword/reducer.js